import { FILTER } from "@/constants";

import { MULTI_SELECT_FILTERS, VALID_FILTERS_KEYS } from "./constants";

export const hasValidFilters = (filters = {}) => {
  //start date can't be considered a filter since it's forced default
  return Object.keys(filters).some((f) => VALID_FILTERS_KEYS.includes(f));
};

export const cleanFilterQuery = (obj) => {
  let applicableFilters = [...VALID_FILTERS_KEYS, FILTER.TAG];

  if (!applicableFilters[FILTER.MIN_REACH]) {
    applicableFilters[FILTER.MIN_REACH] = 0;
  }

  return applicableFilters.reduce((aggr, filter) => {
    aggr[filter] = obj[filter];
    return aggr;
  }, {});
};

export const prepareMultiSelects = (filters) => {
  const preparedFilters = { ...filters };
  Object.keys(filters).forEach((k) => {
    if (MULTI_SELECT_FILTERS.includes(k) && !Array.isArray(filters[k])) {
      preparedFilters[k] = preparedFilters[k] ? [preparedFilters[k]] : [];
    }
  });

  return preparedFilters;
};
